import { Col, Grid, Menu, MenuProps, Row } from "antd"
import { isAdmin, isScientist, isStaff } from "../utils/userUtils"

import React, { useContext, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router"
import { UserContext } from "../context"
import { useMenuContext } from "../context/MenuContext"
import { FadeIn } from "./GeneralComponents"

type MenuItem = Required<MenuProps>["items"][number]

interface LevelKeysProps {
  key?: string
  children?: LevelKeysProps[]
}
const getLevelKeys = (items1: LevelKeysProps[]) => {
  const key: Record<string, number> = {}
  const func = (items2: LevelKeysProps[], level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level
      }
      if (item.children) {
        func(item.children, level + 1)
      }
    })
  }
  func(items1)
  return key
}

function SubMenus(): JSX.Element {
  const user = useContext(UserContext)
  const navigate = useNavigate()
  const location = useLocation()
  const [menuMode, setMenuMode] = useState<"inline" | "horizontal">("inline")
  const { useBreakpoint } = Grid
  const { setShowMenu } = useMenuContext()

  const screens = useBreakpoint()

  const [stateOpenKeys, setStateOpenKeys] = useState<string[]>(["/admin"])
  const items = useMemo(() => {
    let KeysAndLabels=[]
    if (isStaff(user.user)){
      if(isAdmin(user.user)||isScientist(user.user)){  
        KeysAndLabels.push({ key: "/admin/runs", label: "Runs" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){  
        KeysAndLabels.push({ key: "/admin/plates", label: "Plates" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){  
        KeysAndLabels.push({ key: "/admin/orders", label: "Orders" })
      }
      if(isAdmin(user.user)){  
        KeysAndLabels.push({ key: "/admin/invoices", label: "Invoices" })
      }
      if(isAdmin(user.user)){  
        KeysAndLabels.push({ key: "/admin/users", label: "Users" })
      }
      if(isAdmin(user.user)){  
        KeysAndLabels.push({ key: "/admin/usergroups", label: "User Groups" })
      }
      if(isAdmin(user.user)){  
        KeysAndLabels.push({ key: "/admin/promotions", label: "Promotions" })
      }
      if(isAdmin(user.user)){  
         KeysAndLabels.push({ key: "/admin/quotes", label: "Quotes" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){  
        KeysAndLabels.push({ key: "/admin/dropboxes", label: "Dropboxes" })
      }
      if(isAdmin(user.user)){
        KeysAndLabels.push({ key: "/admin/unsubscribes", label: "Unsubscribes" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){  
        KeysAndLabels.push({ key: "/admin/tools", label: "Tools" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){  
         KeysAndLabels.push({ key: "/admin/flowcells", label: "Flow Cells" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){  
        KeysAndLabels.push({ key: "/admin/gpu", label: "GPU" })
      }
      if(isAdmin(user.user)||isScientist(user.user)){
        KeysAndLabels.push({ key: "/admin/minknow", label: "MinKNOW" })
      }
    }
    
      const initialItems: MenuItem[] = [
      {
        key: "/myspace/orderplanning",
        label: "Order Planning",
      },
      {
        key: "/myspace/placeorder",
        label: "Place an Order",
      },
      {
        key: "/myspace/myorders",
        label: "My Orders",
      },
      {
        key: "/myspace/requestquote",
        label: "Request a Quote",
      },
      
      {
        key: "/myspace/faq",
        label: "FAQ",
      },
    ]

    if (isStaff(user.user)) {
      return initialItems.concat([
        {
          key: "/admin",
          label: "admin",
          icon: (
            <span
              className="material-symbols-outlined"
              style={{
                verticalAlign: "middle",
                fontSize: "1rem",
              }}
            >
              admin_panel_settings
            </span>
          ),
          children: KeysAndLabels
        },
      ])
    } else {
      return initialItems
    }
  }, [user.user?.userRole,user.user])

  const [current, setCurrent] = useState("")
  useEffect(() => {
    // console.log(location.pathname)
    if (location.pathname.indexOf("/myspace/myorders") > -1) {
      setCurrent("/myspace/myorders")
    } else if (location.pathname.indexOf("/myspace/requestquote") > -1) {
      setCurrent("/myspace/requestquote")
    } else if (location.pathname.indexOf("/myspace/orderplanning") > -1) {
      setCurrent("/myspace/orderplanning")
    } else if (location.pathname.indexOf("/myspace/faq") > -1) {
      setCurrent("/myspace/faq")
    } else if (/^\/admin$/.test(location.pathname)) {
      setCurrent("/admin")
    } else if (location.pathname.indexOf("/admin/runs") > -1) {
      setCurrent("/admin/runs")
    } else if (location.pathname.indexOf("/admin/plates") > -1) {
      setCurrent("/admin/plates")
    } else if (location.pathname.indexOf("/admin/plate/") > -1) {
      setCurrent("/admin/plates")
    } else if (location.pathname.indexOf("/admin/flowcells") > -1) {
      setCurrent("/admin/flowcells")
    } else if (location.pathname.indexOf("/admin/orders") > -1) {
      setCurrent("/admin/orders")
    } else if (location.pathname.indexOf("/admin/invoices") > -1) {
      setCurrent("/admin/invoices")
    } else if (location.pathname.indexOf("/admin/users") > -1) {
      setCurrent("/admin/users")
    } else if (location.pathname.indexOf("/admin/usergroups") > -1) {
      setCurrent("/admin/usergroups")
    } else if (location.pathname.indexOf("/admin/makeinvoice") > -1) {
      setCurrent("/admin/invoices")
    } else if (location.pathname.indexOf("/admin/promotions") > -1) {
      setCurrent("/admin/promotions")
    } else if (location.pathname.indexOf("/admin/unsubscribes") > -1) {
      setCurrent("/admin/unsubscribes")
    } else if (location.pathname.indexOf("/admin/quotes") > -1) {
      setCurrent("/admin/quotes")
    } else if (location.pathname.indexOf("/admin/dropboxes") > -1) {
      setCurrent("/admin/dropboxes")
    } else if (location.pathname.indexOf("/admin/tools") > -1) {
      setCurrent("/admin/tools")
    } else if (location.pathname.indexOf("/admin/gpu") > -1) {
      setCurrent("/admin/gpu")
    } else if (location.pathname.indexOf("/admin/minknow") > -1) {
      setCurrent("/admin/minknow")
    } else if (/^\/order\/\d+/.test(location.pathname)) {
      //match /order/123
      setCurrent("/myspace/myorders")
    } else if (/^\/admin\/order\/\d+/.test(location.pathname)) {
      //match /order/123
      setCurrent("/admin/orders")
    } else {
        setCurrent('')
    }
  }, [location])
  const levelKeys = getLevelKeys(items as LevelKeysProps[])
  const onOpenChange: MenuProps["onOpenChange"] = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    )
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey])

      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      )
    } else {
      // close
      setStateOpenKeys(openKeys)
    }
  }
  useEffect(() => {
    // Always use inline mode to ensure submenus work properly
    setMenuMode("inline")
  }, [screens.md])

  return (
    <>
      <div>
        <Menu
          style={{ borderBottom: "none" }}
          selectedKeys={[current]}
          onSelect={({ key }) => {
            // console.log(key)
            setCurrent(key)
            navigate(key)
            setShowMenu(false) // Close mobile menu when submenu item is selected
          }}
          mode={menuMode}
          items={items}
          openKeys={stateOpenKeys}
          onOpenChange={onOpenChange}
        />
      </div>
    </>
  )
}

export function WithSubMenus({
  children,
}: {
  children: React.ReactElement
}): JSX.Element {
  return (
    <Row>
      <Col md={4} lg={3} xs={24} sm={24}>
        <div style={{ marginTop: "0.5rem" }}>
          <SubMenus />
        </div>
      </Col>
      <Col md={20} lg={21} sm={24}>
        <div>
          <FadeIn>{children}</FadeIn>
        </div>
      </Col>
    </Row>
  )
}
